type PaginationSummaryProps = {
  totalItems: number;
  singularLabel: string;
  pluralLabel: string;
  className?: string;
  showWhenZero?: boolean;
};

const PaginationSummary = ({
  totalItems,
  singularLabel,
  pluralLabel,
  className,
  showWhenZero = false,
}: PaginationSummaryProps) => {
  if (!showWhenZero && totalItems <= 0) {
    return null;
  }

  const text = totalItems === 1 ? `1 ${singularLabel}` : `${totalItems} ${pluralLabel}`;

  return <p className={`text-sm text-gray-600 mt-4 ${className ?? ""}`.trim()}>{text}</p>;
};

export default PaginationSummary;
